/**
 * Duyarlı yerleşim eşikleri — tek kaynak (Tasarım V2, Dalga 9).
 *
 * ## Neden bir modül?
 *
 * Dar ekran tanımı **iki yerde** yaşıyordu:
 *
 *   - CSS: `@media (max-width: 768px)` (birden çok kural)
 *   - JS:  `PlayerBar.tsx` → `const NARROW_QUERY = '(max-width: 768px)'`
 *
 * JS tarafı eşiği elle yazdığı için, CSS'te eşik değiştiğinde JS sessizce
 * eskide kalıyordu: oynatıcı dar ekran düzenini **geniş** ekranda uygular,
 * dar ekranda uygulamaz — iki katman birbirinden habersiz hareket eder.
 *
 * Burada tek bir ölçek tanımlıdır. CSS tarafı bu değerleri **yorum olarak**
 * kullanır (CSS değişkenleri medya sorgusunda kullanılamaz), JS tarafı ise
 * doğrudan sabitten beslenir. Eşik değiştiğinde iki yer de aynı dosyadan
 * okunur.
 *
 * ## Ölçek
 *
 * | Token | Değer   | Anlamı                                    |
 * |-------|---------|-------------------------------------------|
 * | `xs`  | 480 px  | Büyük telefon (iPhone Pro Max)            |
 * | `sm`  | 768 px  | Tablet dikey / telefon yatay — **dar sınır** |
 * | `md`  | 1024 px | Tablet yatay / küçük dizüstü              |
 * | `lg`  | 1280 px | Masaüstü — kenar çubuğu + yan ray         |
 * | `xl`  | 1600 px | Geniş masaüstü / TV                       |
 *
 * `sm` eşiği **dar ekran sınırıdır**: oynatıcı, alt bar ve alt navigasyon
 * bu eşikte davranış değiştirir.
 */
export const BREAKPOINTS = {
  xs: 480,
  sm: 768,
  md: 1024,
  lg: 1280,
  xl: 1600,
} as const;

export type BreakpointName = keyof typeof BREAKPOINTS;

/** Dar ekran (mobil) medya sorgusu. */
export const NARROW_QUERY = `(max-width: ${BREAKPOINTS.sm}px)`;

/** Geniş masaüstü (kenar çubuğu + yan ray açılır). */
export const WIDE_QUERY = `(min-width: ${BREAKPOINTS.md}px)`;

/** Ekran şu anda dar mı? (SSR/test ortamında güvenli: `false`.) */
export function isNarrowViewport(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(NARROW_QUERY).matches;
}
